import { ActivityIndicator, Text, TouchableOpacity, StyleSheet } from "react-native";

const CustomButton = ({
  title,
  handlePress,
  containerStyles,
  textStyles,
  isLoading,
  isDisabling,
  currentHeight,
}) => {
  return (
    <TouchableOpacity
      onPress={handlePress}
      activeOpacity={0.7}
      disabled={isDisabling}
      style={[
        styles.button,
        containerStyles,
        isDisabling && styles.disabled,
        { height: currentHeight || 50 }, // Imposta un'altezza predefinita se non fornita
      ]}
    >
      <Text style={[styles.text, textStyles]}>
        {title}
      </Text>

      {isLoading && (
        <ActivityIndicator
          animating={isLoading}
          color="#fff"
          size="small"
          style={styles.indicator}
        />
      )}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    backgroundColor: '#000000', // Colore di sfondo
    flexDirection: 'row', // Allineamento orizzontale
    justifyContent: 'center', // Centratura
    alignItems: 'center', // Allineamento verticale
  },
  text: {
    color: '#fff', // Colore del testo
    fontWeight: '600', // Grassetto
    fontSize: 16, // Dimensione del testo
  },
  disabled: {
    opacity: 0.5, // Opacità quando disabilitato
  },
  indicator: {
    marginLeft: 8, // Spazio a sinistra dell'indicatore di caricamento
  },
});

export default CustomButton;
